import { $api } from "@/utils/fetch.ts";

/**
 * Service layer for the Stage-6 "Rights & Roles" capability matrix. Thin `$api`
 * wrappers over the already-shipped, admin-gated capability endpoints
 * (`src/api/capabilities/*`): the override-centric matrix read plus the
 * set/delete grant mutations. No logic lives here — precedence/tri-state
 * derivation is the pure `capabilities-matrix-logic.ts` module.
 *
 * The list is unpaginated by design: it is bounded by admin-authored overrides
 * (org_default + only the explicitly-granted users/teams), not by org headcount,
 * so it never needs pagination (the `teams/list` situation, not `members/list`).
 */
export const capabilitiesQueryOptions = () =>
	$api.queryOptions("get", "/api/capabilities");

/** Upsert an org_default / user / team capability grant (create or update). */
export const useSetCapabilityMutation = () =>
	$api.useMutation("put", "/api/capabilities");

/**
 * Remove an explicit user/team override so precedence falls through to the
 * org_default (distinct from setting `granted=false`, which installs a floor).
 */
export const useDeleteCapabilityMutation = () =>
	$api.useMutation(
		"delete",
		"/api/capabilities/{capability}/{subjectKind}/{subjectRef}",
	);
